import React from "react";
import {} from "antd";
import undefined from "../../assets/images/404.png";
const NotFound: React.FC = () => {
  return (
    <>
      <div className="vm__page-undefined">
        <div className="vm__page-undefined__content">
          <div className="vm__page-undefined__image">
            <img className="vm-signup__logo" src={undefined} alt="" />
          </div>
          <h1>404</h1>
          <h2>Page not Found</h2>
          <p>Sorry the page you are looking for does not exist.</p>
        </div>
      </div>
    </>
  );
};

export default NotFound;
